module.exports = __webpack_public_path__ + "static/media/certificate-star.3d8778cc.gif";